import { initSentry } from './utils/sentry.ts';

// Must be main.tsx's first import: the store starts its sagas, and their first
// requests, as soon as it's imported, and Sentry has to be recording by then.
initSentry();
